import './Client.scss';

import { Button } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
//import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

import {  buttonStylesBlue } from '../../../Components/docsAdministrative/JsObjectStyles';
import {DrawIconeVerifEmail} from '../../../data/SVGs';
import useRole from '../../../hooks/useRole';
function ClientStep0() {
    const navigate = useNavigate();
    const role = useRole();
    const { i18n } = useTranslation();
    const commencer = async (e) => {
        e.preventDefault();
        if(role == 'client' || role == 'esn')
            navigate(`/${role}/completeProfile`);
        else if (role== 'expert')
            navigate('/expert/completeProfile/stepsToFollow');
    };
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [navigate]); // Trigger when the pathname changes

    return (
        <div style={{display:'flex',flexDirection:'column',background:'white',alignItems:'center',width:'100%',height:'100%'}}>
            <div className='Cn1'>
                <h1 className='titreemailver'>{i18n.t('Email verifié')}</h1>
                <DrawIconeVerifEmail />
                <p
                    className='felic'
                    style={{textAlign:'center'}}
                >
                    {i18n.t('Toutes nos félicitations! votre e-mail a été vérifié, vous pouvez maintenant commencer à utiliser High Tech Hires.')}
                </p>
                <div className='Btncommencer'>
                    <Button
                        variant="contained"
                        onClick={commencer}
                        style={{...buttonStylesBlue(),...{width:'100%',}}}
                    >
                        {i18n.t('Commencer')}
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default ClientStep0;

